import React from 'react'
import Name from '../layout/Name'
import Position from '../layout/Position'
import Logo from '../layout/Logo'

const PaidImagePreview = (props) => {
  var order = props.order
  var design = order.design

  const styleObj = { backgroundColor: '' }
  const nameStyleObj = {
    marginLeft: '90px',
    paddingLeft: 0,
    color: ''
  }
  const positionStyleObj = {
    fontSize: '1.5em',
    marginLeft: '90px',
    paddingLeft: 0,
    color: ''
  }
  const logoStyleObj = {
    textAlign: 'right',
    paddingRight: 0,
    color: ''
  }
  var name = order.name
  var position = order.position
  var logo, logoWidth, dropdown

  if (design !== undefined) {
    logo = design.logo
    logoWidth = design.logoWidth
    dropdown = design.dropdown
    styleObj.backgroundColor = design.backgroundColor
    nameStyleObj.color = design.textColor
    positionStyleObj.color = design.textColor
    logoStyleObj.color = design.logoColor
  }
  return (
    <div className="image-preview" style={styleObj}>
      <div className="image-preview-editable">
        <div className="image-preview-name">
          <Name name={name} nameStyleObj={nameStyleObj} />
          <Position position={position} positionStyleObj={positionStyleObj} />
        </div>
        <div className="image-preview-logo">
          <Logo logo={logo} logoWidth={logoWidth} dropdown={dropdown} logoStyleObj={logoStyleObj}/>
        </div>
      </div>
    </div>
  )
}

export default PaidImagePreview
